import { SetupModal } from '@40seas/frontend/libs/entities';
import { IntentsDataProvider } from '@40seas/payments-shared';
import { createContext } from 'react';

export type ModalContextType = SetupModal & {
    isMobile: boolean;
    dataProvider: IntentsDataProvider;
    isAuthenticationEnabled?: boolean;
};

export const ModalContext = createContext<ModalContextType | undefined>(undefined);
